import "../Assests/Styles/Footer.css";

function Footer() {
  return (
    <div className="Footer">
      <p>Created by: <a href="https://romeshkosme.com/" target={"_blank"}>Romesh Kosme</a></p>
    </div>
  )
}

export default Footer